var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0C6.039 0 0 6.038 0 13.5 0 20.961 6.038 27 13.5 27 20.961 27 27 20.962 27 13.5 27 6.039 20.962 0 13.5 0zm0 1.125c6.824 0 12.375 5.551 12.375 12.375S20.324 25.875 13.5 25.875 1.125 20.324 1.125 13.5 6.676 1.125 13.5 1.125z",
    fill: "#2E2D79",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.121 8.997a.972.972 0 0 1 .502.13l6.545 3.722-6.545 5.38a.975.975 0 0 1-.975-.001.977.977 0 0 1-.36-.354l-.126-7.917c0-.266.106-.496.272-.664a1 1 0 0 1 .687-.296z",
    stroke: "#94C83D",
    strokeWidth: 1.2,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.ce977639d675018f9acc9270c0f8428b.svg";
export { ForwardRef as ReactComponent };